import React from 'react';
import CSSModules from 'react-css-modules';
import styles from './styles.scss';
import './loading.gif';

const Loader = (props) => {
  return (
	  <div styleName="loader">
		<div styleName="image">

		</div>
		<div styleName="text">
		  {
			props.text || 'Loading...'
		  }
		</div>
	  </div>
  );
};

export default CSSModules(Loader, styles);



// WEBPACK FOOTER //
// ./common/components/Loader/Loader_component.js